import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  button: {
    id: 'views.CompaniesView.Company.button',
    defaultMessage: 'WIĘCEJ O SPÓŁCE...'
  }
});



// WEBPACK FOOTER //
// ./src/views/Companies/components/Company/Company.intl.js